import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop reordering of images within an album.
// Only active when the album's sort is set to "manual".
// Persists new order via PATCH to albums_images/reorder.

export default class extends Controller {
  static values = { url: String, albumId: Number }

  connect() {
    this._sortable = Sortable.create(this.element, {
      handle:         "[data-sort-handle]",
      draggable:      "[data-sortable-image]",
      animation:      150,
      ghostClass:     "opacity-40",
      chosenClass:    "sortable-chosen-ring",
      forceFallback:  true,
      fallbackOnBody: false,
      swapThreshold:  0.65,
      onEnd:          () => this._persistOrder()
    })
  }

  disconnect() {
    this._sortable?.destroy()
    this._sortable = null
  }

  _persistOrder() {
    const items = this.element.querySelectorAll("[data-sortable-image]")
    const imageIds = Array.from(items).map(el => el.dataset.imageId).filter(Boolean)
    if (imageIds.length === 0) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ album_id: this.albumIdValue, image_ids: imageIds })
    })
  }
}
